import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from '../../../../../store';
import {
  ISaveUser,
  IUserPreference
} from '../../../../../store/ducks/user/types';
import { ModalContent } from './styles';
import {
  updateUserPreferences,
  saveUser as saveUserAction
} from '../../../../../store/ducks/user/actions';
import {
  EOrderTab,
  EOpenColumn,
  EMaterialOpenColumn
} from '../../../../../store/ducks/long-steel-orders/types';
import { Button, Icon, Modal } from '@gerdau/hefesto';
import { Chips } from '@gerdau/hefesto-mais-web';
import { ITaggingParams } from '../../../../../store/ducks/tagging/types';
import { sendTagging } from '../../../../../store/ducks/tagging/actions';

interface IConfigTablesProps {
  orderUserPreference: IUserPreference;
  orderTab: EOrderTab;
}

const ConfigTables: React.FC<IConfigTablesProps> = ({
  orderUserPreference,
  orderTab
}) => {
  const dispatch = useDispatch();
  const user = useSelector((state: ApplicationState) => state.user);

  const [selectedChips, setSelectedChips] = useState<string[]>([
    orderUserPreference?.ordersItens?.idOrder || EOpenColumn.ORDER_NUMBER
  ]);
  const [selectedChipsOld, setSelectedChipsOld] = useState<string>(
    orderUserPreference?.ordersItens?.idOrder || EOpenColumn.OV_GERDAU
  );
  const [selectedChipsMaterial, setSelectedChipsMaterial] = useState<string[]>([
    orderUserPreference?.ordersItens?.idOrder ||
      EMaterialOpenColumn.CLIENT_MATERIAL
  ]);
  const [selectedChipsMaterialOld, setSelectedChipsMaterialOld] =
    useState<string>(
      orderUserPreference?.ordersItens?.idOrder ||
        EMaterialOpenColumn.GERDAU_MATERIAL
    );

  const [canShowModal, setCanShowModal] = useState(false);
  const optionsChoice = [
    { id: EOpenColumn.ORDER_NUMBER, label: 'Nº pedido cliente' },
    { id: EOpenColumn.OV_GERDAU, label: 'Nº OV/item Gerdau' }
  ];
  const optionsMaterialChoice = [
    { id: EMaterialOpenColumn.CLIENT_MATERIAL, label: 'Material Cliente' },
    { id: EMaterialOpenColumn.GERDAU_MATERIAL, label: 'Material Gerdau' }
  ];

  const showModal = () => {
    const taggingParams: ITaggingParams = {
      screenName:
        orderTab === EOrderTab.OPEN
          ? 'LG:MeusPedidos:AcosLongos:PedidosAbertos'
          : 'LG:MeusPedidos:AcosLongos:PedidosFaturados',
      event: 'click',
      itemName: 'button:configurar_tabela',
      itemDescription:
        orderTab === EOrderTab.OPEN
          ? 'meus_pedidos_acosLongos_pedidosAbertos_configurarTabela'
          : 'meus_pedidos_acosLongos_pedidosFaturados_configurarTabela'
    };

    dispatch(sendTagging(taggingParams));
    setCanShowModal(true);
    dispatch(
      sendTagging({
        page: document.location.pathname,
        screenName:
          orderTab === EOrderTab.OPEN
            ? 'LG:MeusPedidos:AcosLongos:PedidosAbertos:ModalConfiguracao'
            : 'LG:MeusPedidos:AcosLongos:PedidosFaturados:ModalConfiguracao',
        event: 'page_view'
      })
    );
  };

  const setIdOrder = (value: string) => {
    if (orderUserPreference && orderUserPreference.ordersItens) {
      const newOrderUserPreference: IUserPreference = {
        ...orderUserPreference,
        ordersItens: {
          ...orderUserPreference.ordersItens,
          idOrder: value
        }
      };
      dispatch(updateUserPreferences(newOrderUserPreference));
    }
  };

  const setIdProduct = (value: string) => {
    if (orderUserPreference && orderUserPreference.ordersItens) {
      const newOrderUserPreference: IUserPreference = {
        ...orderUserPreference,
        ordersItens: {
          ...orderUserPreference.ordersItens,
          idProduct: value
        }
      };
      dispatch(updateUserPreferences(newOrderUserPreference));
    }
  };

  const saveUser = () => {
    const tpCod =
      selectedChipsMaterial[0] === '0' ? 'cod_gerdau' : 'cod_interno';

    const taggingParams: ITaggingParams = {
      screenName:
        orderTab === EOrderTab.OPEN
          ? 'LG:MeusPedidos:AcosLongos:PedidosAbertos:ModalConfiguracao'
          : 'LG:MeusPedidos:AcosLongos:PedidosFaturados:ModalConfiguracao',
      event: 'click',
      itemName: 'button:salvar',
      itemDescription:
        orderTab === EOrderTab.OPEN
          ? 'meus_pedidos_acosLongos_pedidosAbertos_modalConfiguracao_salvar'
          : 'meus_pedidos_acosLongos_pedidosFaturados_modalConfiguracao_salvar',
      filterInfo: `#tpCod:${tpCod}`
    };
    dispatch(sendTagging(taggingParams));
    setCanShowModal(false);
    if (orderUserPreference && orderUserPreference.ordersItens) {
      const saveUserProps: ISaveUser = {
        user: user,
        userPreference: orderUserPreference
      };
      dispatch(saveUserAction(saveUserProps));
      setSelectedChipsOld(
        orderUserPreference.ordersItens?.idOrder || EOpenColumn.ORDER_NUMBER
      );
      setSelectedChipsMaterialOld(
        orderUserPreference.ordersItens?.idProduct ||
          EMaterialOpenColumn.CLIENT_MATERIAL
      );
    }
  };

  const cancelSelect = () => {
    const tpCod =
      selectedChipsMaterial[0] === '0' ? 'cod_gerdau' : 'cod_interno';

    const taggingParams: ITaggingParams = {
      screenName:
        orderTab === EOrderTab.OPEN
          ? 'LG:MeusPedidos:AcosLongos:PedidosAbertos:ModalConfiguracao'
          : 'LG:MeusPedidos:AcosLongos:PedidosFaturados:ModalConfiguracao',
      event: 'click',
      itemName: 'button:cancelar',
      itemDescription:
        orderTab === EOrderTab.OPEN
          ? 'meus_pedidos_acosLongos_pedidosAbertos_modalConfiguracao_cancelar'
          : 'meus_pedidos_acosLongos_pedidosFaturados_modalConfiguracao_cancelar',
      filterInfo: `#tpCod:${tpCod}`
    };
    dispatch(sendTagging(taggingParams));
    cancelSelectedChip();
    cancelSelectedChipMaterial();
    setCanShowModal(false);
  };

  const cancelSelectedChip = () => {
    if (orderUserPreference && orderUserPreference.ordersItens) {
      const newOrderUserPreference: IUserPreference = {
        ...orderUserPreference,
        ordersItens: {
          ...orderUserPreference.ordersItens,
          idOrder: selectedChipsOld
        }
      };
      dispatch(updateUserPreferences(newOrderUserPreference));
      setSelectedChips([selectedChipsOld]);
    }
  };

  const cancelSelectedChipMaterial = () => {
    if (orderUserPreference && orderUserPreference.ordersItens) {
      const newOrderUserPreference: IUserPreference = {
        ...orderUserPreference,
        ordersItens: {
          ...orderUserPreference.ordersItens,
          idProduct: selectedChipsMaterialOld
        }
      };
      dispatch(updateUserPreferences(newOrderUserPreference));
      setSelectedChipsMaterial([selectedChipsMaterialOld]);
    }
  };

  return (
    <>
      <Button
        name="settingTable"
        onClick={showModal}
        variant="secondary"
        icon={<Icon option="Settings" />}
        iconPosition="left"
      >
        Configurar tabela
      </Button>
      {canShowModal && (
        <Modal
          title="Escolha quais informações irão aparecer na primeira linha da tabela"
          onClose={() => {
            setCanShowModal(false);
          }}
          buttons={{
            left: {
              children: 'Cancelar',
              name: 'cancelar',
              onClick: cancelSelect,
              type: 'button'
            },
            right: {
              children: 'Salvar configurações',
              name: 'salvar-configuracoes',
              onClick: saveUser,
              type: 'button'
            }
          }}
          modalSize="sm"
        >
          <ModalContent>
            {orderTab !== EOrderTab.BILLED && (
              <div>
                <span>Identificador do pedido</span>
                <Chips
                  chips={optionsChoice}
                  selectedChipIds={selectedChips}
                  type="choice"
                  handleSelect={(e) => {
                    if (e.length) {
                      const [option] = e;
                      setIdOrder(option);
                      setSelectedChips(e);
                      return;
                    }

                    setSelectedChips([
                      orderUserPreference.ordersItens?.idOrder ||
                        EOpenColumn.ORDER_NUMBER
                    ]);
                  }}
                />
              </div>
            )}

            <div>
              <span>Identificador do produto</span>
              <Chips
                chips={optionsMaterialChoice}
                selectedChipIds={selectedChipsMaterial}
                type="choice"
                handleSelect={(e) => {
                  if (e.length) {
                    const [option] = e;
                    setIdProduct(option);
                    setSelectedChipsMaterial(e);
                    return;
                  }

                  setSelectedChipsMaterial([
                    orderUserPreference?.ordersItens?.idProduct ||
                      EMaterialOpenColumn.CLIENT_MATERIAL
                  ]);
                }}
              />
            </div>
          </ModalContent>
        </Modal>
      )}
    </>
  );
};

export default ConfigTables;
